import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useLocalizedLink } from "../../hooks/useLocalizedLink";
import ServiceGallery from "./ServiceGallery";

function ServicePageContent({ serviceType }) {
  const { t } = useTranslation();
  const getLocalizedPath = useLocalizedLink();

  const serviceTypes = {
    "single-room": "singleRoom",
    "double-room": "doubleRoom",
    "triple-room": "tripleRoom",
    "quad-room": "quadRoom",
    "six-room": "sixRoom",
    "social-areas": "socialAreas",
    transportation: "transportation",
    "nearby-places": "nearbyPlaces",
    "nearby-universities": "nearbyUniversities",
  };

  // Her hizmet için uygun banner görseli
  const serviceBannerImages = {
    'single-room': '/assets/img/2-3-kisilik/2-3-kisilik-dikey (1).jpeg',
    'double-room': '/assets/img/2-3-kisilik-yatay/2-3-kisilik-yatay (1).jpeg',
    'triple-room': '/assets/img/2-3-kisilik/2-3-kisilik-dikey (2).jpeg',
    'quad-room': '/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/14.jpg',
    'six-room': '/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/17.jpg',
    'social-areas': '/assets/img/yurt-fotograf/yemekhane/5.jpg',
    'transportation': '/assets/img/yurt-fotograf/dis-cephe/33.jpg',
    'nearby-places': '/assets/img/yurt-fotograf/dis-cephe/36.jpg',
    'nearby-universities': '/assets/img/yurt-fotograf/dis-cephe/40.jpg',
  };

  const currentService = serviceTypes[serviceType];

  if (!currentService) {
    return (
      <div className="container">
        <div className="text-center py-5">
          <h2>{t("common.serviceNotFound")}</h2>
          <Link to={getLocalizedPath("/service")} className="th-btn">
            {t("common.backToServices")}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <section className="space">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="service-content">
              <div className="service-image mb-40 global-img">
                <img
                  src={serviceBannerImages[serviceType] || `/assets/img/normal/service_${
                    Object.keys(serviceTypes).indexOf(serviceType) + 1
                  }.jpg`}
                  alt={`Haseki Sultan Kız Öğrenci Yurdu - ${t(`service.${currentService}.title`)}`}
                  title={`Haseki Sultan Kız Öğrenci Yurdu - ${t(`service.${currentService}.title`)}`}
                  className="w-100 rounded"
                  onError={(e) => {
                    e.target.src = "/assets/img/normal/resort_1_1.jpg";
                  }}
                />
              </div>

              <div className="service-description">
                <p 
                  className="box-text mb-30"
                  dangerouslySetInnerHTML={{ __html: t(`service.${currentService}.description`) }}
                />
              </div>

              {/* Room Features Section - For single, double, triple and quad rooms */}
              {(serviceType === 'single-room' || serviceType === 'double-room' || serviceType === 'triple-room' || serviceType === 'quad-room') && (
                <>
                  <div className="room-features mb-40">
                    <h3 className="box-title mb-20">
                      {t(`service.${currentService}.roomFeatures.title`)}
                    </h3>
                    <ul className="feature-list" style={{ listStyle: 'none', paddingLeft: 0 }}>
                      {t(`service.${currentService}.roomFeatures.features`, { returnObjects: true }).map((feature, index) => (
                        <li key={index} className="box-text mb-10">
                          <i className="fal fa-check-circle me-2 text-primary" />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="general-facilities mb-40">
                    <h3 className="box-title mb-20">
                      {t(`service.${currentService}.generalFacilities.title`)}
                    </h3>
                    <ul className="facility-list" style={{ listStyle: 'none', paddingLeft: 0 }}>
                      {t(`service.${currentService}.generalFacilities.facilities`, { returnObjects: true }).map((facility, index) => (
                        <li key={index} className="box-text mb-10">
                          <i className="fal fa-check-circle me-2 text-primary" />
                          {facility}
                        </li>
                      ))}
                    </ul>
                  </div>
                </>
              )}

              <div className="service-actions text-center mt-60">
                <Link
                  to={getLocalizedPath("/contact")}
                  className="th-btn style3 me-3"
                >
                  {t("nav.onlineRegistration")}
                </Link>
                <Link
                  to={getLocalizedPath("/service")}
                  className="th-btn style4"
                >
                  {t("nav.services")}
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Service Gallery Section */}
        <ServiceGallery serviceType={serviceType} />
      </div>
    </section>
  );
}

export default ServicePageContent;
